import axios from "@/axios.js";
import BatchClients from "./batch_clients_service";

export default {
   getAllBatchClients() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/batch_clients/batch_clients/get_all_batch_clients`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchBatchClients(context, batch_clientsId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/batch_clients/batch_clients/${batch_clientsId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeBatchClients(context, batch_clientsId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/batch_clients/batch_clients/${batch_clientsId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getExistingBatchClientsLists(context, batch_clients_from) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/batch_clients/batch_clients/get_existing_batch_clients_lists/${batch_clients_from}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  searchExistingBatchClientsLists(context, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/batch_clients/batch_clients/search_existing_batch_clients_lists", {
          item: item
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateBatchClients({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/batch_clients/batch_clients/update_batch_clients", {
          item: item
        })
        .then(response => {
        
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addBatchClients({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/batch_clients/batch_clients/add_batch_clients", {
          item: item
        })
        .then(response => {
          // // console.log(response)
          commit(
            "ADD_ITEM",
            Object.assign(item, {
              id: response.data.id
            })
          );
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeBatchClients({ commit }, batch_clientsId) {
    return new Promise((resolve, reject) => {
      // alert(roleId)
      axios
        .delete(`/api/batch_clients/batch_clients/${batch_clientsId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
